import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';
import AnimatedNumber from '../AnimatedNumber';
import Sparkline from '../Sparkline';
import PeopleIcon from '@material-ui/icons/People';
import ListIcon from '@material-ui/icons/List';
import PersonIcon from '@material-ui/icons/Person';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import BlockIcon from '@material-ui/icons/Block';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';

const styles = theme => ({
  root: {
    height: '100%',
    borderRadius: 12,
    padding: theme.spacing(1.5),
    background: 'linear-gradient(135deg,#071227 0%, #0b2b48 100%)',
    border: '1px solid rgba(255,255,255,0.04)',
    color: '#e6eef8',
    boxShadow: '0 10px 30px rgba(2,6,23,0.5)',
    transition: 'transform 180ms ease, box-shadow 180ms ease',
    '&:hover': {
      transform: 'translateY(-6px)',
      boxShadow: '0 18px 50px rgba(2,6,23,0.7)'
    }
  },
  title: {
    fontWeight: 600,
    color: '#cfeffb',
    fontSize: '0.9rem'
  },
  headerRow: { display: 'flex', alignItems: 'center', gap: theme.spacing(1) },
  value: {
    fontWeight: 800,
    fontSize: '1.9rem',
    marginTop: theme.spacing(0.5),
    color: '#ffffff'
  },
  avatar: {
    background: 'linear-gradient(135deg,#0ea5b3,#036ea6)',
    height: 56,
    width: 56,
    boxShadow: '0 8px 24px rgba(3,48,71,0.32)'
  },
  icon: {
    height: 32,
    width: 32,
    color: '#fff'
  },
  smallMuted: { color: 'rgba(255,255,255,0.72)', fontSize: '0.8rem' }

});

class StatisticCard extends Component {

  renderIcon = (icon, classes) => {
    if (icon === "pending") {
      return <HourglassFullIcon className={classes.icon} />
    }  else if (icon === "rejected") {
      return <ThumbDownIcon className={classes.icon} />
    } else if (icon === "approved") {
      return <ThumbUpIcon className={classes.icon} />
    } else if (icon === "disabled") {
      return <BlockIcon className={classes.icon} />
    } else if (icon === "consumer"){
      return <PeopleIcon className={classes.icon} />
    } else if (icon === "servicerequest") {
      return <ListIcon className={classes.icon} />
    } else if (icon === "serviceproviders") {
      return <PersonIcon className={classes.icon} />;
    } else if (icon === "total_consumer"){
      return <PeopleIcon className={classes.icon} />
    }  else {
      return null;
    }
  }

  render() {
    const { classes, ...rest } = this.props;

    return (
      <Card className={classes.root}>
        <CardContent>
          <Grid container justify="space-between" alignItems="center">
            <Grid item style={{ flex: 1 }}>
              <div className={classes.headerRow}>
                <Typography className={classes.title} gutterBottom>
                  {rest.title}
                </Typography>
                {rest.sparkData && <Sparkline data={rest.sparkData} />}
              </div>
              <div className={classes.value}>
                <AnimatedNumber value={Number(rest.num || 0)} duration={900} format={(v) => v.toLocaleString()} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6 }}>
                {typeof rest.trend !== 'undefined' && (
                  <div style={{
                    background: rest.trend >= 0 ? 'rgba(34,197,94,0.12)' : 'rgba(239,68,68,0.08)',
                    color: rest.trend >= 0 ? '#22c55e' : '#ef4444',
                    padding: '4px 8px',
                    borderRadius: 12,
                    fontWeight: 600,
                    fontSize: '0.8rem'
                  }}>
                    {rest.trend >= 0 ? '▲' : '▼'} {Math.abs(rest.trend)}%
                  </div>
                )}
                {rest.sub && <div className={classes.smallMuted}>{rest.sub}</div>}
              </div>
            </Grid>
            <Grid item>
              <Avatar className={classes.avatar}>{this.renderIcon(rest.icon, classes)}</Avatar>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default connect(null, null)(withStyles(styles)(StatisticCard));